import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar'
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar'
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

import axios from 'axios'

class Home extends Component {
  constructor(props) {
    super(props)

    this.state = {
      credentials: [],
      snackOpen: false,
      snackMessage: '',
    }

    this.loadCredentials()
  }

  loadCredentials = () => {
    axios.get('/api/credentials', {
    }).then( response => {
      console.log(response);
      if (response.data.ok !== 'ok') {
        return;
      }
      this.setState({
        credentials: response.data.items
      });
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  componentWillMount(){
    console.log("willmount prop values",this.props)
  }

  handleSnackClose = () => {
    this.setState({
      snackOpen: false,
      snackMessage: ''
    })
  }

  handleLogout = (e) => {
    axios.get('/api/logout')
    .then((response) => {
      console.log(response)
      if (response.data.ok === 'ok') {
        sessionStorage.user = null
        window.location.href = '/login'
      } else {
        this.setState({
          snackOpen: true,
          snackMessage: 'ログアウトに失敗しました。'
        })
      }
    })
    .catch((error) => {
      console.log(error)
      this.setState({
        snackOpen: true,
        snackMessage: 'ログアウトに失敗しました。'
      })
    })
  }

  handleChangeNote = (cname) => (e, v) => {
    const credentials = this.state.credentials
    for (let c of credentials) {
      if (c.cname === cname) {
        c.note = v
        break
      }
    }
    this.setState({
      credentials: credentials
    })
  }

  handleSaveNote = (cname, note) => (e) => {
    var payload = {
      "note": note,
    }

    axios.put(`/api/credential/${cname}`, payload)
    .then((response) => {
      console.log(response)
      if (response.data.ok === 'ok') {
        this.setState({
          snackOpen: true,
          snackMessage: `${cname}のメモを更新しました。`
        })
      } else {
        this.setState({
          snackOpen: true,
          snackMessage: 'メモの更新に失敗しました。'
        })
      }
    })
    .catch((error) => {
      console.log(error)
      this.setState({
        snackOpen: true,
        snackMessage: 'メモの更新に失敗しました。'
      })
    })
  }

  handleDelete = (cname) => (e) => {
    if (!window.confirm(`${cname}を削除します。\nよろしいですか？`)) {
      return
    }
    axios.delete(`/api/credential/${cname}`)
    .then((response) => {
      console.log(response)
      if (response.data.ok === 'ok') {
        let credentials = this.state.credentials
        let idx = 0
        for (const c of credentials) {
          if (c.cname === cname) {
            credentials.splice(idx, 1)
          }
          idx++
        }
        this.setState({
          snackOpen: true,
          snackMessage: `${cname}を削除しました。`,
          credentials: credentials,
        })
      } else {
        this.setState({
          snackOpen: true,
          snackMessage: '削除に失敗しました。'
        })
      }
    })
    .catch((error) => {
      console.log(error)
      this.setState({
        snackOpen: true,
        snackMessage: '削除に失敗しました。'
      })
    })
  }

  render() {
    let rows = []
    const credentials = this.state.credentials
    for (const c of credentials) {
      rows.push(
        <TableRow key={c.cname}>
          <TableRowColumn>{c.cname}</TableRowColumn>
          <TableRowColumn>{c.created_at}</TableRowColumn>
          <TableRowColumn>
            <TextField
              hintText='メモ'
              defaultValue={c.note}
              fullWidth={true}
              underlineStyle={style.underlineStyle}
              onChange={this.handleChangeNote(c.cname)}
            />
          </TableRowColumn>
          <TableRowColumn
            style={style.actionRow}
          >
            <FlatButton
              primary={true}
              label="メモ更新"
              onClick={this.handleSaveNote(c.cname, c.note)}
            />
            <FlatButton
              primary={true}
              label="削除"
              onClick={this.handleDelete(c.cname)}
            />
          </TableRowColumn>
        </TableRow>
      )
    }

    return (
      <div style={style.root}>
        <AppBar
          title="アクセス管理画面"
          showMenuIconButton={false}
          iconElementRight={
            <FlatButton
              label="Logout"
              onClick={this.handleLogout}
            />
          }
        />
        <Table
          selectable={false}
          multiSelectable={false}
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>ID</TableHeaderColumn>
              <TableHeaderColumn>利用開始日時</TableHeaderColumn>
              <TableHeaderColumn>メモ</TableHeaderColumn>
              <TableHeaderColumn
                style={style.actionRow}
              >
                操作
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
          >
            {rows}
          </TableBody>
        </Table>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={2000}
          onRequestClose={(e) => this.handleSnackClose(e)}
        />
      </div>
    );
  }
}

const style = {
  root: {
    textAlign: 'center'
  },
  underlineStyle: {
    borderColor: 'white',
  },
  actionRow: {
    width: '20rem',
  },
}

export default Home;




// WEBPACK FOOTER //
// ./src/pages/Home.js